<script>
export default {
    name: 'IconBookmark',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-bookmark"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M16 8h32v48L32 40 16 56z"
            fill-rule="evenodd"
        />
    </svg>
</template>
